import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class ProceedToPayment extends Event {
    eventName = 'oms_proceedToPayment';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Proceed To Payment
     * 
     * @param {string} data.order_id -  order id
     * @param {string} data.success_url -  success url
     * @param {string} data.error_url -  error url
     * @param {string} data.payment_method -  payment method
     * @param {string} data.retry - retry (0 or 1)
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let orderId = data.order_id;
        let successUrl = data.success_url;
        let errorUrl = data.error_url;
        let payment_method_id = data.payment_method.id;
        let retry = data.retry;
        let locationId = new LocalStorage.CurrentLocation(clientId).getData();


        if (orderId) {
          // request data
          data.endPoint = application_settings.endPoints.proceedToPayment;
          data.method = 'POST';
          data.data = {
              client_id: clientId,
              order_id: orderId,
              success_url: successUrl,
              error_url: errorUrl,
              payment_method_id: payment_method_id,
              retry: retry,
          };
          
          // send request
          this.sendRequest(data, function (response) {
            if (response) {
              //format response data
              let data = thisObj.formatResponseData(response);

              if (data.success) {
                let cartLocation = new LocalStorage.CartLocation(locationId);
                cartLocation.removeData();
              }

              //fire success event
              thisObj.onSuccessEvent(data, {
                action: action,
                request_id: requestId,
              });

              let orderDetails = new LocalStorage.OrderDetails(
                clientId
              ).getData();

              if (orderDetails && orderDetails.data) {
                orderDetails = orderDetails.data;

                orderDetails.delivery_info.date = null;
                orderDetails.delivery_info.time = null;
                orderDetails.delivery_info.shippingPrice = null;
                orderDetails.payment_info.loyaltyPoints = null;
                orderDetails.more_info = [];

                new LocalStorage.OrderDetails(clientId).setData(orderDetails);
              }
            }
          });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "orderId is required", "status": 422 });
        }
    }


}

export default ProceedToPayment;